/**
 * The accent classes the token layer defines. Indexed rather than computed,
 * because Tailwind only emits classes it can see written out.
 */
const PHASE_ACCENT_CLASS = [
  'phase-accent-0',
  'phase-accent-1',
  'phase-accent-2',
  'phase-accent-3',
] as const;

export function phaseAccentClass(accentIndex: number): string {
  return PHASE_ACCENT_CLASS[accentIndex % PHASE_ACCENT_CLASS.length];
}
